import { datestamp, timestamp } from "../util"

interface ImportClientDate {
	ClientDate: string
	ClientDateTime: string
}

export const importDateNow = (): ImportClientDate => {
	return {
		ClientDate: datestamp(),
		ClientDateTime: timestamp(),
	}
}
